export default {"src":"/_next/static/media/relaxing.79021939.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};